import React from "react";
import { useSearchParams } from "react-router-dom";
import { InfoCard } from "../components/info-card.tsx";

export function TestCallback() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const error = params.get("error");

  if (error) {
    return <InfoCard title="Sign-in failed" description={error} />;
  }

  if (code) {
    return (
      <InfoCard
        title="Sign-in successful"
        description="The OIDC flow completed and authed.co issued an authorization code. A real OIDC client would now exchange this code at the /token endpoint for an ID token."
      >
        <div className="break-all border-2 border-faint p-3 font-mono text-xs text-muted">
          code: {code}
        </div>
      </InfoCard>
    );
  }

  return (
    <InfoCard
      title="Test callback"
      description="Open this page via the Test sign-in button on an application."
    />
  );
}
